export const CATEGORY_PAWN = [
  { id: 1, label: "เครื่องประดับ" },
  { id: 2, label: "อิเล็กทรอนิกส์" },
  { id: 3, label: "ทองคำ" },
  { id: 4, label: "พระเครื่อง" },
  { id: 5, label: "แบรนด์เนม" },
  { id: 6, label: "นาฬิกา" },
];
